__turbopack_context__.v({
  "flex": "styles-module-scss-module__5vW11q__flex",
  "headerResult": "styles-module-scss-module__5vW11q__headerResult",
  "noWrap": "styles-module-scss-module__5vW11q__noWrap",
  "resultBodyWrapper": "styles-module-scss-module__5vW11q__resultBodyWrapper",
  "resultDescription": "styles-module-scss-module__5vW11q__resultDescription",
  "resultHead": "styles-module-scss-module__5vW11q__resultHead",
  "searchResult": "styles-module-scss-module__5vW11q__searchResult",
  "searchTable": "styles-module-scss-module__5vW11q__searchTable",
  "symbolWrapper": "styles-module-scss-module__5vW11q__symbolWrapper",
});
